import { handleTabs, handleOS } from './lib/deeplink';

handleOS();
handleTabs();



// WEBPACK FOOTER //
// ./install.js